import BemIt, { addClass } from "@gtechdoodler/bem-it";
import StyledRatingBadge from "./RatingBadge.styles";
import { RatingBadgeProps } from "./RatingBadge.types";

const RatingBadge: React.FC<RatingBadgeProps> = ({
	className,
	iconPosition = "right",
	size = "lg",
	...props
}) => {
	const block = new BemIt("RatingBadge");

	return (
		<StyledRatingBadge
			className={addClass(className).after(block.mod(size))}
			size={size}
			iconPosition={iconPosition}
			{...props}
		/>
	);
};

export default RatingBadge;
